import axios from 'axios';

// Request interceptor to add auth token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Check for authentication errors
    const status = error.response?.status;
    const message = error.response?.data?.message || '';
    
    // Handle token expiration or unauthorized access
    if (
      status === 401 || 
      status === 403 ||
      message.toLowerCase().includes('token') ||
      message.toLowerCase().includes('unauthorized') ||
      message.toLowerCase().includes('expired')
    ) {
      console.log('Auth error detected, redirecting to login...', {
        status,
        message
      });
      
      // Clear all auth data
      localStorage.removeItem('authToken');
      localStorage.removeItem('admin');
      
      // Redirect to login page
      if (window.location.pathname !== '/signin') {
        window.location.href = '/signin';
      }
    }
    
    return Promise.reject(error);
  }
);

export default axios;
